export default __webpack_public_path__ + "static/media/element_34.b3c87ad0.webp";